// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChangingLanguage_wrapperTooltip__C-w-e.ChangingLanguage_wrapperTooltip__C-w-e {
  background-color: transparent;
  padding: 0;
}

.ChangingLanguage_tooltip__rLymY.ChangingLanguage_tooltip__rLymY {
  background-color: #fff;
  border-radius: 8px;
}

.ChangingLanguage_tooltip__rLymY.ChangingLanguage_tooltip__rLymY span {
  color: var(--color-black-500, #577487);
}

.ChangingLanguage_tooltip__rLymY.ChangingLanguage_tooltip__rLymY button span {
  color: var(--color-black-main, #364954);
}

.ChangingLanguage_tooltip__rLymY.ChangingLanguage_tooltip__rLymY button:hover {
  background-color: #45dcc6;
}

.ChangingLanguage_tooltip__rLymY.ChangingLanguage_tooltip__rLymY button:active {
  background-color: #0c6154;
}

.ChangingLanguage_tooltip__rLymY.ChangingLanguage_tooltip__rLymY button:active span {
  color: #fff;
}

.ChangingLanguage_lngButton__iuH1a {
  color: #678aa1;
}

.ChangingLanguage_lngActive__sgpsE {
  color: #55bbeb;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/ChangingLanguage/ChangingLanguage.module.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".wrapperTooltip.wrapperTooltip {\n  background-color: transparent;\n  padding: 0;\n}\n\n.tooltip.tooltip {\n  background-color: #fff;\n  border-radius: 8px;\n}\n\n.tooltip.tooltip span {\n  color: var(--color-black-500, #577487);\n}\n\n.tooltip.tooltip button span {\n  color: var(--color-black-main, #364954);\n}\n\n.tooltip.tooltip button:hover {\n  background-color: #45dcc6;\n}\n\n.tooltip.tooltip button:active {\n  background-color: #0c6154;\n}\n\n.tooltip.tooltip button:active span {\n  color: #fff;\n}\n\n.lngButton {\n  color: #678aa1;\n}\n\n.lngActive {\n  color: #55bbeb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapperTooltip": `ChangingLanguage_wrapperTooltip__C-w-e`,
	"tooltip": `ChangingLanguage_tooltip__rLymY`,
	"lngButton": `ChangingLanguage_lngButton__iuH1a`,
	"lngActive": `ChangingLanguage_lngActive__sgpsE`
};
export default ___CSS_LOADER_EXPORT___;
